export enum PublicRotes {
  HOME = '/',
  AUTH = '/auth/',
  PRIVACY = '/privacy/',
  DELETE_ACCOUNT = '/delete-account/'
}
